import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { DataService } from '../services/data.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private dataService: DataService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.dataService.getToken();
        let locale = this.dataService.getCurrentLang();
        if (!locale) {
            locale = 'en';
        }

        if (token) {
            request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`,
                  Locale: locale
                },
                withCredentials: true
              });
        } else {
            this.dataService.clearUserData();
            request = request.clone({
                withCredentials: true
            });
        }
        return next.handle(request);
    }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/token.interceptor.ts